<span>
    <button class="button tiny" attr.aria-label="{{btnText}}" (click)="click($event)">
        {{btnText}}
    </button>
</span>
